import { gql } from '@apollo/client';

export const USER_QUERY = gql`
  {
    user {
      id
      email
      firstName
      lastName
      isPso
      isSuperuser
      isShowcaseUser
      primaryRole
      permissions
    }
  }
`;

export const LOGGED_IN_PATIENT_QUERY = gql`
  {
    patient {
      id
      ida
    }
  }
`;
